import { Edit, MoreVertical, Tag, Trash2 } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'

import { TaxClass } from '@/types/taxes'

export const TaxClasses = () => {
  // Mock data
  const classes: TaxClass[] = [
    {
      id: '1',
      name: 'Standard Rate',
      description: 'Default tax class for most products',
      slug: 'standard',
      createdAt: new Date(),
    },
    {
      id: '2',
      name: 'Reduced Rate',
      description: 'For essential items like food and books',
      slug: 'reduced',
      createdAt: new Date(),
    },
    {
      id: '3',
      name: 'Zero Rate',
      description: 'Tax-exempt products',
      slug: 'zero',
      createdAt: new Date(),
    },
    {
      id: '4',
      name: 'Digital Goods',
      description: 'Special rate for digital downloads',
      slug: 'digital',
      createdAt: new Date(),
    },
  ]

  return (
    <div>
      <div className="border-t border-border-subtle">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Class</TableHead>
              <TableHead>Description</TableHead>
              <TableHead>Slug</TableHead>
              <TableHead>Created</TableHead>
              <TableHead className="w-12"><span className="sr-only">Actions</span></TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {classes.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} className="py-8 text-center text-text-2">
                  <Tag className="mx-auto mb-2 size-8 text-muted-foreground" />
                  <p className="text-sm">No tax classes found</p>
                </TableCell>
              </TableRow>
            ) : (
              classes.map((taxClass) => (
                <TableRow key={taxClass.id}>
                  <TableCell className="font-medium text-ink">{taxClass.name}</TableCell>
                  <TableCell className="text-text-2">{taxClass.description}</TableCell>
                  <TableCell>
                    <code className="rounded-sm bg-muted px-1.5 py-0.5 font-mono text-xs text-ink">{taxClass.slug}</code>
                  </TableCell>
                  <TableCell className="text-sm tabular-nums text-text-2">
                    {new Date(taxClass.createdAt).toLocaleDateString()}
                  </TableCell>
                  <TableCell>
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button variant="ghost" size="icon" aria-label="Actions">
                          <MoreVertical className="size-4" />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent align="end">
                        <DropdownMenuItem>
                          <Edit className="size-4" />
                          Edit
                        </DropdownMenuItem>
                        <DropdownMenuItem className="text-destructive">
                          <Trash2 className="size-4" />
                          Delete
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  )
}
